import { useQuery } from "@tanstack/react-query";

import Axios from "@/lib/axios-instance";

export interface ChatLogData {
  date: string;
  count: number;
}

export interface ChatLogResponse {
  meta: {
    error: boolean;
    code: number;
    message: string;
  };
  data: ChatLogData[];
}

export const getChatsGraph = async () => {
  try {
    const response = await Axios.get<ChatLogResponse>(
      `/chat_logs/stats/chats-graph`
    );
    return response.data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    if (error.response) {
      throw new Error(error?.response?.data?.message || error?.response?.data?.error || "Error fetching chats graph data");
    }
    throw new Error(error.message || "Network Error");
  }
};

export const useGetChatsGraph = () => {
  return useQuery({
    queryKey: ["chats_graph"],
    queryFn: getChatsGraph,
  });
};